/**
 * Search-field contract shared by the settings widget grids
 * (legacy /settings and the alpha profile page).
 */
export interface SettingsWidgetSearchFields {
  title: string;
  description: string;
  searchText: string;
  keywords: string[];
}

/**
 * Case-insensitive substring match over a widget's title, description,
 * dynamic search text, and keywords. An empty or whitespace query matches
 * every widget.
 */
export function matchesWidget(widget: SettingsWidgetSearchFields, query: string): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;

  return [
    widget.title,
    widget.description,
    widget.searchText,
    ...widget.keywords,
  ]
    .join(" ")
    .toLowerCase()
    .includes(normalized);
}
